var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: _vm.debounceOnResize,
      expression: "debounceOnResize"
    }],
    staticStyle: {
      "height": "100%"
    }
  }, [_c('image-position-selector', {
    ref: "selector",
    attrs: {
      "editValues": _vm.editValues,
      "src": _vm.currentPage.src,
      "scaleX": _vm.currentPage.scaleX,
      "scaleY": _vm.currentPage.scaleY,
      "isSigning": _vm.isSigning,
      "documentTokens": _vm.currentDocumentToken,
      "currentPageNumber": _vm.currentPageNumber,
      "supressKeyboardActions": true,
      "pageCount": _vm.pages.length
    },
    on: {
      "save": _vm.save,
      "previousPage": function previousPage($event) {
        return _vm.$emit('previousPage');
      },
      "nextPage": function nextPage($event) {
        return _vm.$emit('nextPage');
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }